export default {
  pillars: {
    sectionTitle: 'Guias e recursos da Basetao',
    sectionSubtitle:
      'Guias práticos sobre planilhas, envio, QC, vendedores, segurança e mais.',
    readMore: 'Ler o guia',
    guide: {
      title: 'O guia completo da planilha Basetao',
      desc: 'Crie e use uma planilha Basetao para organizar links, vendedores, QC e envio.',
    },
    review: {
      title: 'Avaliação da Basetao',
      desc: 'Como funciona o agente Basetao, seus pontos fortes e limites.',
    },
    shipping: {
      title: 'Guia de custos de envio da Basetao',
      desc: 'Entenda como os custos de envio são calculados e como economizar.',
    },
    warehouse: {
      title: 'Guia do armazém da Basetao',
      desc: 'Como funcionam o armazenamento, a consolidação e o QC no armazém da Basetao.',
    },
    qc: {
      title: 'Guia de QC e controle de qualidade da Basetao',
      desc: 'O que verificar nas fotos de QC e como detectar problemas cedo.',
    },
    sellers: {
      title: 'Guia de vendedores confiáveis da Basetao',
      desc: 'Como avaliar e escolher vendedores confiáveis para o seu pedido.',
    },
    coupons: {
      title: 'Cupons e códigos de desconto da Basetao',
      desc: 'Onde encontrar descontos e como usá-los com honestidade.',
    },
    safety: {
      title: 'A Basetao é legítima e segura?',
      desc: 'Passos práticos para proteger sua conta, pagamentos e compras.',
    },
    vs: {
      title: 'Comparação Basetao vs Superbuy',
      desc: 'Compare taxas, recursos e fluxo de trabalho de dois agentes populares.',
    },
    beginner: {
      title: 'Guia para iniciantes da Basetao',
      desc: 'Um guia simples passo a passo para o seu primeiro pedido na Basetao.',
    },
  },
};